var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Input as ElInput } from 'element-ui';
var LHBInput = /** @class */ (function (_super) {
    __extends(LHBInput, _super);
    function LHBInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LHBInput.prototype, "textAttrs", {
        // 设置属性默认值
        get: function () {
            return Object.assign({ clearable: true }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LHBInput.prototype, "textListerners", {
        get: function () {
            var _this = this;
            return Object.assign({}, this.$listeners, {
                input: function (value) {
                    if (['number', 'float'].indexOf(_this.customType) > -1) {
                        if (_this.customType === 'number') { // 输入纯数字
                            value = value.replace(/\D/g, '');
                        }
                        else if (_this.customType === 'float') { // 输入浮点数
                            value = value.replace(/[^\d\.]/g, '');
                            if (value) {
                                var _value = value.split('.');
                                if (_value.length === 3) {
                                    if (value.slice(-1) === '.') {
                                        value = value.slice(0, -1);
                                    }
                                    else {
                                        return null;
                                    }
                                }
                                else if (_value.length > 3) {
                                    return null;
                                }
                                else {
                                    // 处理浮点长度
                                    if (_value[1] && _value[1].length > _this.floatLength) {
                                        value = value.slice(0, value.length - (_value[1].length - _this.floatLength));
                                    }
                                }
                            }
                        }
                        if (_this.limitBeginningRepeatZero && value) {
                            var arr = value.split('.');
                            if (arr.length < 2 || (arr[0].length > 1 && +arr[1])) {
                                value = +value;
                            }
                            if (arr.length === 2 && arr[0].length > 1 && !+arr[1]) {
                                value = value.replace(/^0+([1-9]*)\./, function (match, first) {
                                    return first ? first + "." : "0" + first + ".";
                                });
                            }
                        }
                    }
                    // 控制在最大值内
                    if (value && _this.max && +value > +_this.max) {
                        value = _this.max;
                    }
                    if (value && _this.min && +value < +_this.min) {
                        value = _this.min;
                    }
                    _this.$emit('input', value);
                },
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LHBInput.prototype, "$target", {
        get: function () {
            return this.$refs.target;
        },
        enumerable: false,
        configurable: true
    });
    LHBInput.prototype.focus = function () {
        this.$refs.target.focus();
    };
    __decorate([
        Prop({
            type: String,
        })
    ], LHBInput.prototype, "customType", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 2,
        })
    ], LHBInput.prototype, "floatLength", void 0);
    __decorate([
        Prop({
            type: [String, Number],
        })
    ], LHBInput.prototype, "max", void 0);
    __decorate([
        Prop({
            type: [String, Number],
        })
    ], LHBInput.prototype, "min", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], LHBInput.prototype, "limitBeginningRepeatZero", void 0);
    LHBInput = __decorate([
        Component({
            components: { ElInput: ElInput },
        })
    ], LHBInput);
    return LHBInput;
}(Vue));
export default LHBInput;
